<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentToDo /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/team/dashboard/HeaderDash.vue'
import SideMenu from '@/components/team/dashboard/SideMenu.vue'
import ContentToDo from '@/components/team/dashboard/modules/to-do/ContentToDo.vue'

export default 
{
  name: 'ToDo',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentToDo
  }
}
</script>
<style>

</style>